export interface TechFeatureSubmitApiRequest {
    task_id: string;
    tech_features: {
        /**
         * 技术特征
         */
        tech_feature: string;
        /**
         * 是否为核心技术特征
         */
        core: boolean;
        /**
         * 是否为用户添加
         */
        user_add: boolean;
    }[];
}

export type TechFeatureSubmitApiResponse = void;

/**
 * 技术特征提交 API
 */
export interface FtoReportTechFeatureSubmitApi {
    /**
     * 提交技术特征
     */
    submitTechFeature(data: TechFeatureSubmitApiRequest): Promise<TechFeatureSubmitApiResponse>;
}

export const FtoReportTechFeatureSubmitApi = Symbol.for('FtoReportTechFeatureSubmitApi');
